<template>
  <div id="page-user-list">
    <vx-card
      ref="filterCard"
      title="Filters"
      class="user-list-filters mb-8"
      collapse-action
      refresh-content-action
      @refresh="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <!-- <vs-checkbox v-model="checkBox1" vs-value="complete">Complete</vs-checkbox> -->
          <label class="text-sm opacity-75">Status</label>
          <v-select
            multiple
            :options="statusOptions"
            :clearable="true"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="statusFilter"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full">
          <!-- <vs-checkbox v-model="checkBox1" vs-value="complete">Complete</vs-checkbox> -->
          <label class="text-sm opacity-75">Venue</label>
          <v-select
            :options="venueOptions"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="venueFilter"
            class="mb-4 md:mb-0"
          />
        </div>
        <vs-spacer></vs-spacer>
        <div class="vx-col md:w-1/4 sm:w-1/2 pull-right">
          <!-- <vs-checkbox v-model="checkBox1" vs-value="complete">Complete</vs-checkbox> -->
          <label class="text-sm opacity-75">Date From</label>
          <datepicker
            class="mb-4 md:mb-0"
            :disabledDates="disabledDates"
            placeholder="From Date"
            v-model="filter.dateFrom"
          ></datepicker>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 pull-right">
          <!-- <vs-checkbox v-model="checkBox1" vs-value="complete">Complete</vs-checkbox> -->
          <label class="text-sm opacity-75">Date To</label>
          <datepicker
            class="mb-4 md:mb-0"
            :disabledDates="disabledDates"
            placeholder="To Date"
            v-model="filter.dateTo"
          ></datepicker>
        </div>
        <vs-button
          class="mt-5"
          @click="
            currentx = 1;
            getFilteredData(1);
          "
          radius
          icon="icon-search"
          icon-pack="feather"
        />
      </div>
    </vx-card>

    <vx-card>
      <vs-prompt
        title="Export To Excel"
        class="export-options"
        @cancel="clearFields"
        @accept="exportToExcel"
        accept-text="Export"
        @close="clearFields"
        :active.sync="activePrompt"
      >
        <vs-input
          v-model="fileName"
          placeholder="Enter File Name.."
          class="w-full"
        />
        <v-select v-model="selectedFormat" :options="formats" class="my-4" />
        <div class="flex">
          <span class="mr-4">Cell Auto Width:</span>
          <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
        </div>
      </vs-prompt>

      <div class="export-table">
        <vs-table
          :data="bookings"
          v-model="selectedBookings"
          search
          :total="totalItems"
          :max-items="itemsPerPage"
          multiple
        >
          <template slot="header">
            <vs-button @click="activePrompt = true">Export</vs-button>
          </template>
          <template slot="thead">
            <vs-th sort-key="id">ID</vs-th>
            <vs-th sort-key="id">GhostID</vs-th>
            <vs-th sort-key="name">Venue Name</vs-th>
            <vs-th sort-key="street">Street</vs-th>
            <vs-th sort-key="city">City</vs-th>
            <vs-th sort-key="order_time">Order Time</vs-th>
            <vs-th sort-key="pickup_time">Pickup Time</vs-th>
            <vs-th sort-key="status">Booking Status</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].id">{{ data[indextr].id }}</vs-td>
              <vs-td :data="data[indextr].api_booking_id">{{ data[indextr].api_booking_id }}</vs-td>
              <vs-td :data="data[indextr].venue.name">{{
                data[indextr].venue.name
              }}</vs-td>
              <vs-td :data="data[indextr].venue.street">{{
                data[indextr].venue.street
              }}</vs-td>
              <vs-td :data="data[indextr].venue.city">{{
                data[indextr].venue.city
              }}</vs-td>
              <vs-td :data="data[indextr].order_time">{{
                data[indextr].order_time
              }}</vs-td>
              <vs-td :data="data[indextr].pickedup_at_time">{{
                data[indextr].pickedup_at_time
              }}</vs-td>
              <vs-td :data="data[indextr].status">{{
                data[indextr].status
              }}</vs-td>
              <!-- <vs-td>{{ data[indextr].payment_type == 'debit' ? (data[indextr].amount*-1): ''}}</vs-td>
            <vs-td>{{ data[indextr].payment_type == 'credit' ? data[indextr].amount: ''}}</vs-td>
              <vs-td>{{ data[indextr].balance }}</vs-td>-->
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination class="mt-2" :total="totalPages" v-model="currentx"></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>
<script>
import { _status_list } from "@/services/Order";
import {
  _list_venues,
  _list_bookings,
  _filter_bookings,
  _filter_bookings_without_pagination,
  // _filter_date_bookings,
} from "@/services/Company";

import vSelect from "vue-select";

import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      payments: [],
      bookings: [],
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "csv",
      headerTitle: [
        "Id",
        "API ID",
        "Venue Name",
        "Street",
        "City",
        "Order Time",
        "Pickup Time",
        "Booking Status",
      ],
      headerVal: [
        "id",
        "api_booking_id",
        "venue_name",
        "venue_street",
        "venue_city",
        "order_time",
        "pickup_time",
        "status",
      ],
      selectedBookings: [],
      activePrompt: false,
      paymentDetailPrompt: false,
      details: [],
      preBalance: 0,
      statusOptions: [],
      statusFilter: [],
      venueFilter: { label: "All", value: "all" },
      venueOptions: [],
      companyID: this.$store.state.company.companyID,
      filter: {
        status: [],
        venue: "all",
        dateFrom: null,
        dateTo: null,
      },
      // dateFrom: null,
      // dateTo: null,
      disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth() - 2), // Disable all dates up to specific date
        from: new Date(), // Disable all dates after specific date
      },
      currentx: 1,
      totalItems: 1000,
      itemsPerPage: 1000,
      totalPages: 1,
    };
  },
  beforeMount() {
    this.getFilteredData(this.currentx);
    // this.getBookings(this.currentx);
    this.getStatusList();
    this.getVenues();
  },
  watch: {
    "$store.state.company.companyID"(val) {
      this.currentx = 1;
      this.companyID = val;
      this.getBookings(this.currentx);
      this.getStatusList();
      this.getVenues();
    },
    statusFilter(obj) {
      this.filter.status = [];
      let value = obj.map((o) => o.value);
      this.filter.status = value;
      this.currentx = 1;
      this.getFilteredData(this.currentx);
    },
    venueFilter(obj) {
      this.filter.venue = obj.value;
      this.currentx = 1;
      this.getFilteredData(this.currentx);
    },
    currentx(val) {
     if (this.filter.status.length || this.filter.venue) {
        this.getFilteredData(val);
      } else {
        this.getBookings(this.currentx);
      }
    },
  },
  methods: {
    getFilteredData(page = 1) {
      this.$vs.loading();
      if (this.filter.dateFrom) {
        this.filter.dateFrom = moment(this.filter.dateFrom).startOf("day").format("YYYY-MM-DD 00:00:00");
        if (this.filter.dateTo)
          this.filter.dateTo = moment(this.filter.dateTo).endOf("day").format("YYYY-MM-DD 23:59:59");
        else
          this.filter.dateTo = moment().endOf("day").format("YYYY-MM-DD 23:59:59");

      }
      _filter_bookings(this.companyID, this.filter, page)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.bookings = response.data.obj.list.data;
            this.totalPages = response.data.obj.list.last_page;
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: err.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    resetColFilters() {
      this.statusFilter = [];
      this.venueFilter = { label: "All", value: "all" };
      this.getStatusList();
      this.getVenues();
      this.currentx = 1;
      this.getBookings(this.currentx);

      this.filter.dateTo = null;
      this.filter.dateFrom = null;

      this.$refs.filterCard.removeRefreshAnimation();
    },
    getVenues() {
      _list_venues(this.companyID)
        .then(
          (res) => {
            this.venueOptions = res.data.obj.list;
            this.venueOptions.unshift({ label: "All", value: "all" });
          },
          (err) => {
            this.$vs.notify({
              title: err.response.data.responseTitle,
              text: err.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((err) => {
          this.$vs.notify({
            text: err.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    getStatusList() {
      _status_list()
        .then(
          (res) => {
            this.statusOptions = res.data.obj.list;
          },
          (err) => {
            console.log(err);
            this.$vs.notify({
              title: err.response.data.responseTitle,
              text: err.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((err) => {
          console.log(err);
          this.$vs.notify({
            text: err.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    getBookings(page) {
      this.$vs.loading();
      _list_bookings(this.$store.state.company.companyID, page)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.bookings = response.data.obj.list.data;
            this.totalPages = response.data.obj.list.last_page;
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    exportToExcel() {
      this.$vs.loading();
      if (this.filter.dateFrom) {
        this.filter.dateFrom = moment(this.filter.dateFrom).startOf("day").format("YYYY-MM-DD 00:00:00");
        if (this.filter.dateTo)
          this.filter.dateTo = moment(this.filter.dateTo).endOf("day").format("YYYY-MM-DD 23:59:59");
        else
          this.filter.dateTo = moment().endOf("day").format("YYYY-MM-DD 23:59:59");
      }
      _filter_bookings_without_pagination(this.companyID, this.filter)
        .then(res => {
          this.$vs.loading.close();
          import("@/vendor/Export2Excel").then((excel) => {
            const list = this.selectedBookings.length
              ? this.selectedBookings
              : res.data.obj.list;
            const data = this.formatJson(this.headerVal, list);
            excel.export_json_to_excel({
              header: this.headerTitle,
              data,
              filename: this.fileName,
              autoWidth: this.cellAutoWidth,
              bookType: this.selectedFormat,
            });
            this.clearFields();
          });
        });



    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j == "venue_name") return v.venue.name;
          else if (j == "venue_street") return v.venue.street;
          else if (j == "venue_city") return v.venue.city;
          else if (j == "order_time") return v.booked_at_time;
          else if (j == "pickup_time") return v.created_at;
          else return v[j];
        })
      );
    },
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "csv";
    },
    // filterBookings(page = 1) {
    //   if (!this.dateFrom) {
    //     return alert("select some date to filter");
    //   }
    //   if (!this.dateTo) {
    //     this.dateTo = new Date();
    //   }

    //   const data = {
    //     from: moment(this.dateFrom)
    //       .startOf("day")
    //       .format("YYYY-MM-DD 00:00:00"),
    //     to: moment(this.dateTo).endOf("day").format("YYYY-MM-DD 23:59:59"),
    //   };
    //   _filter_date_bookings(this.companyID, data, page)
    //     .then(
    //       (res) => {
    //         this.bookings = res.data.obj.list.data;
    //         this.totalPages = res.data.obj.list.last_page
    //       },
    //       (error) => {
    //         this.$vs.notify({
    //           title: error.response.data.responseTitle,
    //           text: error.response.data.responseMessage,
    //           iconPack: "feather",
    //           icon: "icon-cross-circle",
    //           color: "danger",
    //         });
    //       }
    //     )
    //     .catch((error) => {
    //       this.$vs.notify({
    //         text: error.message,
    //         iconPack: "feather",
    //         icon: "icon-cross-circle",
    //         color: "danger",
    //       });
    //     });
    // },

    handleSearch(searching) {
      let _print = `The user searched for: ${searching}\n`;
      // console.log(searching);
    },
    handleChangePage(page) {
      let _print = `The user changed the page to: ${page}\n`;
      console.log(page);
    },
  },
};
</script>

